import { ReactNode, createContext, useContext, useEffect, useState } from 'react'
import UserContext from './user'
import { getExperiences } from 'shared/components/user-onboarding/user-onboarding.api'

export type ExperienceRecord = {
    experience_id: string
    status: number
    create_datetime: string
    update_datetime: string
}

export type ExperiencesContextProps = {
    experiences: ExperienceRecord[]
}

const ExperiencesContext = createContext({
    experiences: [],
} as ExperiencesContextProps)

export const ExperiencesContextManager = ({ children }: { children: ReactNode }) => {
    const { user } = useContext(UserContext)
    const [experiences, setExperiences] = useState<ExperienceRecord[]>([])

    useEffect(() => {
        if (user && !user.loggedIn) {
            return
        }
        getExperiences().then((experiences) => {
            setExperiences(experiences)
        })
    }, [user])
    return <ExperiencesContext.Provider value={{ experiences }}>{children}</ExperiencesContext.Provider>
}

export default ExperiencesContext
